
import CommonButton from '~/components/common/button/CommonButton.vue'
import { commonfunc } from '~/mixin/common'
import mbUtils from '~/scriptData/mb/utils/mbUtils'

export default {
  name: 'AddAddress',
  components: {
    CommonButton
  },
  mixins: [commonfunc, mbUtils],
  layout: '',
  props: {
    purchaseValue: { // 01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량배송
      type: String,
      default: '01'
    },
    addrInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    registered: { // 배송지유무
      type: Boolean,
      default: false
    },
    page: { // 컴포넌트 사용 페이지
      type: String,
      default: ''
    },
  },
  data () {
    const customValid = (rule, value, callback) => {
      if (rule.field === 'rqstTy') {
        if (this.form.rqstTy === 'Z' && this.form.rqstMtr.length > 50) {
          callback(new Error('최대 50자 입력가능합니다.'))
        }
      } else if (rule.field === 'rcpmCntp1Etno') {
        if (!this.form.rcpmCntp1Etno.startsWith('010')) {
          callback(new Error('010으로 시작하는 휴대폰번호를 입력해 주세요.'))
        } else if (this.form.rcpmCntp1Etno.replace(/-/gi, '').length > 11) {
          callback(new Error('최대 11자 입력 가능합니다.'))
        } else if (this.form.rcpmCntp1Etno.replace(/-/gi, '').length < 11) {
          callback(new Error('유효한 휴대폰 번호를 입력해 주세요'))
        }
      } else if (rule.field === 'addrZip') {
        // 2024.01.11. 세 개의 필드에 하나의 검증 메세지를 띄워야 하므로 custom validator로 변경.
        if (!this.isNotEmpty(this.form.addrZip) || !this.isNotEmpty(this.form.addrBassEaddr)) {
          callback(new Error('주소를 입력해 주세요.'))
        } else if (!this.isNotEmpty(this.form.dtlEaddr)) {
          callback(new Error('상세주소를 입력해 주세요.'))
        }
      }

      callback()
    }
    return {
      labelPosition: 'top',
      rqstMtr: [],
      cmmnCdList: [],
      form: {
        action: 'ins',
        mbMngNo: '',
        lsUpdrId: '',
        dvyaNm: '',
        rcpmEfnm: '',
        bassDvyaYn: 'N',
        rcpmCntp1Etno: '',
        addrZip: '',
        addrBassEaddr: '',
        dtlEaddr: '',
        rqstTy: '',
        // agrYn: 'N',
        rqstMtr: ''
      },
      bassDvyaYnDisabled: false,
      rules: {
        dvyaNm: [
          { required: true, message: '배송지명을 입력해 주세요.', trigger: 'blur' },
          { max: 9, message: '최대 9자 입력가능합니다.', trigger: 'blur' }
        ],
        rcpmEfnm: [
          { required: true, message: '수령인 이름을 입력해 주세요.', trigger: 'blur' },
          { pattern: /^[0-9가-힣a-zA-Z\s]+$/i, message: '올바른 이름을 입력해 주세요', trigger: 'blur' }
        ],
        rcpmCntp1Etno: [
          { required: true, message: '휴대폰번호를 입력해 주세요.', trigger: 'blur' },
          { validator: customValid, trigger: 'blur' }
        ],

        // addrZip: [
        //   { required: true, message: '주소를 입력해 주세요.', trigger: 'blur' }
        // ],
        // dtlEaddr: [
        //   { required: true, message: '상세주소를 입력해 주세요.', trigger: 'blur' }
        // ],
        // 2024.01.11. 상세주소가 검증되지 않는 오류 확인.
        // 세 개의 필드에 하나의 검증 메세지를 띄워야 하므로 custom validator로 변경.
        addrZip: [
          { required: true, message: '주소를 입력해 주세요.', trigger: 'blur' },
          { validator: customValid, trigger: 'blur' }
        ],

        rqstTy: [
          { validator: customValid, trigger: 'blur' }
        ],
        rqstMtr: [
          { max: 50, message: '최대 50자 입력가능합니다.', trigger: 'blur' }
        ]
      }
    }
  },
  // 우편번호
  head () {
    return {
      title: '다이소몰 : 배송지 등록',
      script: [{ src: '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js' }]
    }
  },
  created () {
    if (this.form.action === 'ins') {
      this.titleNm = '배송지 등록'
      Object.keys(this.form).forEach((key) => {
        if (key !== 'action') {
          this.form[key] = ''
        }
      })
      if (this.bassDvyaYnDisabled) {
        this.form.bassDvyaYn = 'Y'
      } else {
        this.form.bassDvyaYn = 'N'
      }
      this.form.agrYn = 'N'
    } else if (this.form.action === 'upd') {
      this.titleNm = '배송지 수정'
      this.form.addrBassEaddr = this.unescape(this.form.addrBassEaddr)
      this.form.dtlEaddr = this.unescape(this.form.dtlEaddr)
    }
    if (this.$refs.form !== undefined) {
      this.$refs.form.clearValidate()
    }
  },
  async mounted () {
    const grpList = ['CD_00162']
    this.cmmnCdList = await this.selCmmnCd(grpList) // 공통 코드
    this.rqstMtr = this.cmmnCdFilter(this.cmmnCdList, 'CD_00162', '', '')
    if (this.purchaseValue === '04' && (this.$store.getters['ds/getBulkOrderDeliveryFormShow'].addrZip !== undefined) && (this.addrInfo.addrZip === undefined || this.addrInfo.addrBassEaddr === undefined)) {
      this.form.addrZip = this.$store.getters['ds/getBulkOrderDeliveryFormShow'].addrZip
      this.form.addrBassEaddr = this.$store.getters['ds/getBulkOrderDeliveryFormShow'].addrBassEaddr
      this.$store.commit('ds/setBulkOrderDeliveryFormShow', '')
    } else if (this.purchaseValue === '04') {
      this.form.addrZip = this.addrInfo.addrZip
      this.form.addrBassEaddr = this.addrInfo.addrBassEaddr
    }
  },
  methods: {
    addrSrch () { // 대량주문이외에 사용하는 경우, 주소 찾기 추가 개발 필요
    },
    closePp () {
      this.$emit('closePopup')
    },
    setPhoneFormat () {
      this.form.rcpmCntp1Etno = this.empnoFormat(event.target.value)
    },
    dvyaSave (formName) {
      console.log(this.form)
      this.form.rcpmEfnm = this.form.rcpmEfnm.replace(/^\s+|\s+$/g, '')

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.dvyaNm.length > 9) {
            this.$alert('배송지명은 최대 9자 입력가능합니다.')
            return false
          } else if (this.form.rcpmEfnm.length > 10) {
            this.$alert('수령인 이름은 최대 10자 입력가능합니다.')
            return false
          } else if (this.form.dtlEaddr.length > 50) {
            this.$alert('상세주소는 최대 50자 입력가능합니다.')
            return false
          } else {
            this.form.rqstMtr = this.form.rqstTy === 'Z' ? this.form.rqstMtr : ''
            this.form.bassDvyaYn = 'Y'
            this.$AxiosBuilder
              .data(this.form)
              .build()
              .post('/mb/mbc/saveDvya')
              .then((res) => {
                console.log(res)
                if (this.isNotEmpty(res.data.data)) {
                  const data = res.data.data
                  if (res.data.success) {
                    this.$emit('next', 3)
                  } else {
                    console.log('saveDvya error: ', data)
                    this.openToast('주소등록에 실패하였습니다.')
                  }
                }
              })
              .catch((err) => {
                console.log('error')
                console.log(err)
              })
            // }
          }
        } else if (this.form.dvyaNm === '' || this.form.rcpmEfnm === '' || this.form.rcpmCntp1Etno === '' ||
          this.form.addrZip === '' || this.form.addrBassEaddr === '' || this.form.dtlEaddr === '') {
          this.$alert(this.$t('CM.WRITE_REQUIRED_FORM'))
          return false
        }
      })
    }
  }
}
